/**
 * Bulandi 2026 workshops — images in `public/Bulandi Workshop/`.
 * Each workshop posts to its own Apps Script deployment; set exec URLs in `src/config/workshopWebApps.json`.
 * Each workshop also has its own WhatsApp group invite that is sent to the registrant on success.
 *
 * `workshopDate` (YYYY-MM-DD): after this day (local time), the tile moves to Past workshops
 * and registration is hidden. Partition via `partitionBulandiWorkshops`.
 */
import workshopExecUrls from "../config/workshopWebApps.json";

const workshopImage = (filename) => encodeURI(`/Bulandi Workshop/${filename}`);

const isDev = process.env.NODE_ENV === "development";

function registrationUrlForWorkshop(id) {
  const raw = String(workshopExecUrls[id] || "").trim();
  if (!raw) return "";
  return isDev ? `/workshop-exec/${id}` : raw;
}

/** @type {Array<{ id: string; title: string; workshopDate: string; detailsImageUrl: string; feeLabel: string; registrationWebAppUrl: string; spreadsheetUrl: string; whatsappGroupUrl: string; requiresPaymentScreenshot?: boolean; registrationOpen?: boolean; registrationClosedLabel?: string; attendeesLabel?: string }>} */
export const bulandiWorkshops2026 = [
  {
    id: "the-ai-edge",
    title: "The AI Edge",
    workshopDate: "2026-05-31",
    detailsImageUrl: workshopImage("The AI Edge.png"),
    feeLabel: "Free",
    attendeesLabel: "300+",
    requiresPaymentScreenshot: false,
    spreadsheetUrl:
      "https://docs.google.com/spreadsheets/d/1oIu43OHla8lZnA73e1H_Tkqe0b6Bpkm_4xyzm7rqrMk/edit",
    registrationWebAppUrl: registrationUrlForWorkshop("the-ai-edge"),
    whatsappGroupUrl: "https://chat.whatsapp.com/Dl09HSpJVHpJdJZ0HUMXTV?mode=gi_t",
  },
  {
    id: "art-of-rock-balancing",
    title: "ART OF rock BALANCING",
    workshopDate: "2026-06-07",
    detailsImageUrl: workshopImage("Art of Rock Balancing.png"),
    feeLabel: "₹300",
    attendeesLabel: "100",
    registrationOpen: false,
    registrationClosedLabel: "Sold out",
    spreadsheetUrl:
      "https://docs.google.com/spreadsheets/d/1oETlx-0KYWkVwdx-I3y-56j5sBKcaMFGXp3_wqRmR5U/edit",
    registrationWebAppUrl: registrationUrlForWorkshop("art-of-rock-balancing"),
    whatsappGroupUrl: "https://chat.whatsapp.com/Jg33wX2xFGb1NTXvSJ7cZK?mode=gi_t",
  },
  {
    id: "scientific-goal-setting",
    title: "Scientific goal setting",
    workshopDate: "2026-06-14",
    detailsImageUrl: workshopImage("Scientific Goal Setting.png"),
    feeLabel: "₹250",
    spreadsheetUrl:
      "https://docs.google.com/spreadsheets/d/1PR58HPQU8BTW2DrR_3qvdK0JewoChZ3t_40t-GMFI6o/edit",
    registrationWebAppUrl: registrationUrlForWorkshop("scientific-goal-setting"),
    whatsappGroupUrl: "https://chat.whatsapp.com/ClKYfXRUvRAB47OmjRQJQG?mode=gi_t",
  },
  {
    id: "the-speaking-edge",
    title: "The speaking edge",
    workshopDate: "2026-06-14",
    detailsImageUrl: workshopImage("The Speaking Edge.png"),
    feeLabel: "₹200",
    registrationOpen: false,
    registrationClosedLabel: "Sold out",
    spreadsheetUrl:
      "https://docs.google.com/spreadsheets/d/1DFPRX1ypnIPry6djgrY4wWtOtPzQK_nj7oUzUL46mog/edit",
    registrationWebAppUrl: registrationUrlForWorkshop("the-speaking-edge"),
    whatsappGroupUrl: "https://chat.whatsapp.com/FfpC81MyroIKgLQ9OlNJ0R?mode=gi_t",
  },
  {
    id: "design-thinking",
    title: "Design Thinking",
    workshopDate: "2026-06-28",
    detailsImageUrl: workshopImage("Design Thinking.png"),
    feeLabel: "₹400",
    spreadsheetUrl:
      "https://docs.google.com/spreadsheets/d/1eA6M2jeUFmd1eKl4LUIM51EpCUwSgvCa4tiy4nlQt8E/edit",
    registrationWebAppUrl: registrationUrlForWorkshop("design-thinking"),
    whatsappGroupUrl: "https://chat.whatsapp.com/CwpF2cucbrm8KgZ69rS3Ds?mode=gi_t",
  },
];
